import React from 'react'
import PropTypes from 'prop-types'
import cls from 'classnames'

import spinner from '@cred/global-assets/images/misc/spinner.svg'

import styles from './styles.module.scss'

const LoadingSpinner = ({
  className,
  open = false,
  fixed = false,
  staticPosition = false,
  ...props
}) =>
  open && (
    <div
      className={cls(styles.spinnerMainContainer, className, {
        [styles.fixed]: fixed,
        [styles.static]: staticPosition,
      })}
      {...props}
    >
      <img src={spinner} alt="Loading..." height="50" />
    </div>
  )

LoadingSpinner.propTypes = {
  open: PropTypes.bool,
  className: PropTypes.string,
  fixed: PropTypes.bool,
  staticPosition: PropTypes.bool,
}

export { LoadingSpinner as LoadingSpinnerNoHOC }
export default LoadingSpinner
